import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { retrieve } from "../../shared/api";
import "./Footer.scss";

const Footer = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    retrieve("/api/footer").then((res) => {
      console.log("footer data", res);
      setData(res.data);
    });
  }, []);
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="left-links">
          <Link to="/courses">
            <i className="fas fa-microphone footer-icon"></i>
            Courses & Workshops
          </Link>

          <Link to="/book">
            <i className="fas fa-book footer-icon"></i>
            Publishings & Literary
          </Link>
          <Link to="/training">
            <i className="fab fa-audible footer-icon"></i>
            Training Materials
          </Link>
        </div>
        <div className="right-links">
          <a href="https://www.facebook.com/Lynnjac2022">
            <i className="fab fa-facebook-square footer-icon"></i>
            Facebook
          </a>
          <a href="https://www.instagram.com/estherljackson/">
            <i className="fab fa-instagram-square footer-icon"></i>
            Instagram
          </a>
          <a href="https://twitter.com/elynnjac">
            <i className="fab fa-twitter-square footer-icon"></i>
            Twitter
          </a>
        </div>

        <div className="middle-links">
          <Link to="/about">
            <i className="fas fa-address-card footer-icon"></i>
            About
          </Link>

          <Link to="/contact">
            <i className="fas fa-mobile footer-icon"></i>
            Contact
          </Link>
          <a href="https://www.linkedin.com/in/drestherjackson">
            <i className="fab fa-linkedin footer-icon"></i>
            LinkedIn
          </a>
        </div>
      </div>
      <span className="footer-name">
        Lynnjac Consulting &copy; {data.year}{" "}
      </span>
      <span className="powered-by-name">Powered By: CMJ Software </span>
    </div>
  );
};

export default Footer;
